import React from 'react'
import { message } from 'antd'
import { useStopTask, useChangeJobPause, useChangeJobStart } from '../utils'
import { Message } from '@/components/message'
import { t } from '@/i18n'

export const useTaskHandlers = () => {
  const [stopTask] = useStopTask()
  const [changeJobPause] = useChangeJobPause()
  const [changeJobStart] = useChangeJobStart()

  const handleStopTask = async (id: string, _taskId: string, refreshCallback: () => void) => {
    try {
      await stopTask({ result_id: id })
      refreshCallback()
      Message.success({ content: t('任务停止成功'), className: 'task-success' })
    } catch (error) {
      console.log(error)
    }
  }

  const handleOpenTask = async (id: string, taskStatus: number, refreshCallback: () => void) => {
    try {
      if (taskStatus === 1) {
        await changeJobPause({ taskId: id })
      } else {
        await changeJobStart({ taskId: id })
      }

      if (taskStatus === 1) {
        Message.error({ content: t('任务暂停'), className: 'task-error' })
      } else {
        Message.info({ content: t('任务启动'), className: 'task-info' })
      }

      refreshCallback()
    } catch (error: any) {
      if (error.code === 400) {
        message.warn({
          className: 'task-warn',
          content: React.createElement('span', null, [
            React.createElement('div', { style: { textAlign: 'left' } }, t('任务异常，无法运行')),
            React.createElement('div', null, `${t('异常原因：')}${error.msg}`),
          ]),
        })
      }
    }
  }

  return {
    handleStopTask,
    handleOpenTask,
  }
}
